module.exports = __webpack_public_path__ + "static/img/btn2_hover.cfdf6f6b.png";